// extracted by mini-css-extract-plugin
module.exports = {"container":"_2s6cSZjg2txFsJfKS_uod7"};